import { render, staticRenderFns } from "./AttributeCard.vue?vue&type=template&id=e0aa64a2&scoped=true&"
import script from "./AttributeCard.vue?vue&type=script&lang=js&"
export * from "./AttributeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0aa64a2",
  null
  
)

export default component.exports